import { BasicWithLibelleModel } from './../basic/basicWithLibelle.model';
import { BasicModel } from '../basic/basic.model';

export class CondReglModel extends BasicModel implements BasicWithLibelleModel {
        // max length 7
        code: string;
        // max length 30
        libelle: string;
        // max length 7
        mode: string;
}
